<template>
  <ul
    :id="'boss-tabs-control-'+suffix"
    class="vertical tabs boss-jobtype-menu"
    data-tabs
  >
    <li
      v-for="(categories,index) in masterData"
      :key="categories.id"
      :class="index === 0 ? 'is-active' : ''"
      class="tabs-title boss-jobtype-menu-item"
    >
      <a
        :href="`#boss-categories-${categories.id}-${suffix}`"
        class="boss-jobtype-menu-title"
        aria-selected="true"
      >
        <span class="boss-jobtype-menu-title-text">{{ categories.name }}</span>
        <div
          v-if="tabCount(categories.id) > 0"
          class="boss-selected-item"
        >
          <span class="boss-selected-item-text">選択中</span>
          <span class="boss-selected-item-number">{{ tabCount(categories.id) }}</span>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
import Foundation from 'foundation-sites'
import jQuery from 'jquery'

export default {
  props: {
    suffix: {
      type: String,
      required: true
    },
    masterDataMap: {
      type: Object,
      required: true
    },
    masterData: {
      type: Array,
      required: true
    },
    depth: {
      type: Number,
      required: true
    }
  },
  computed: {
    hasCategory () {
      return this.depth > 2
    }
  },
  mounted () {
    this.tabSelect = new Foundation.Tabs(jQuery('#boss-tabs-control-' + this.suffix), {
      // These options can be declarative using the data attributes
      matchHeight: false
    })
  },
  destroyed () {
    this.tabSelect.destroy()
  },
  methods: {
    tabCount (categoriesId) {
      if (this.hasCategory) {
        return this.masterData
          .find(categories => categories.id === categoriesId).children
          .reduce((acc, category) => {
            const checkedNum = Object.values(this.masterDataMap[categoriesId][category.id]).filter(v => v.check).length
            return acc + checkedNum
          }, 0)
      } else {
        return this.masterData
          .find(categories => categories.id === categoriesId).children
          .reduce((acc, cur) => {
            return this.masterDataMap[categoriesId][cur.id].check ? acc + 1 : acc
          }, 0)
      }
    }
  }
}
</script>
